import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

class LocalPickup extends Component {
  connectedCallback() {
    super.connectedCallback();

    const closestSection = this.closest(`.shopify-section, dialog`);

    /** @type {(event: VariantUpdateEvent) => void} */
    const variantUpdated = (event) => {
      if (event.detail.data.newProduct) {
        this.dataset.productUrl = event.detail.data.newProduct.url;
      }

      const variantId = event.detail.resource ? event.detail.resource.id : null;
      const variantAvailable = event.detail.resource ? event.detail.resource.available : null;
      if (variantId !== this.dataset.variantId) {
        if (variantId && variantAvailable) {
          this.dataset.variantId = variantId;
          // Reuses the HTML already fetched for this variant update (see
          // assets/variant-picker.js) instead of issuing a second section
          // request -- this used to fetch its own copy of the same page,
          // adding a fully sequential extra round-trip after the main
          // variant request had already resolved.
          const wrapper = event.detail.data.html.querySelector(`local-pickup[data-variant-id="${variantId}"]`);
          if (wrapper) {
            this.removeAttribute('hidden');
            morph(this, wrapper);
          } else {
            this.setAttribute('hidden', '');
          }
        } else {
          this.setAttribute('hidden', '');
        }
      }
    };

    closestSection?.addEventListener(ThemeEvents.variantUpdate, variantUpdated);

    this.disconnectedCallback = () => {
      closestSection?.removeEventListener(ThemeEvents.variantUpdate, variantUpdated);
    };
  }
}

if (!customElements.get('local-pickup')) {
  customElements.define('local-pickup', LocalPickup);
}
